var _rect, _g, _path, _rect2, _rect3, _rect4, _tspan, _tspan2, _path2, _tspan3, _path3, _path4, _path5, _tspan4, _path6, _tspan5, _path7, _tspan6, _path8, _tspan7, _path9, _tspan8, _path10, _tspan9, _path11, _tspan10, _path12, _tspan11, _path13, _tspan12, _path14, _path15, _tspan13, _path16, _tspan14, _path17, _tspan15, _path18, _tspan16, _path19, _tspan17, _path20, _tspan18, _path21, _tspan19, _path22, _tspan20, _tspan21, _path23, _tspan22, _tspan23, _tspan24, _tspan25, _g2, _rect5, _tspan26, _tspan27, _tspan28, _g3, _rect6, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _g4, _rect7, _path24, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _g5, _rect8, _tspan44, _tspan45, _tspan46, _tspan47, _g6, _rect9, _tspan48, _tspan49, _tspan50, _tspan51, _g7, _rect10, _path25, _path26, _path27, _path28, _tspan52, _tspan53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1442,
    height: 546,
    viewBox: "0 0 1442 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1442,
    height: 546,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g_svg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_bkg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    width: 1442,
    height: 546,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g_info"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1388 89.71H19V100.43H1388V89.71Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 81,
    transform: "translate(1281 269)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 1318,
    y: 281,
    width: 14,
    height: 18,
    fill: "#D83F3F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 1318,
    y: 320,
    width: 14,
    height: 18,
    fill: "#195193"
  })), /*#__PURE__*/React.createElement("text", {
    id: "China",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 1353,
    y: 298.545
  }, "China"))), /*#__PURE__*/React.createElement("text", {
    id: "India",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 1353,
    y: 333.545
  }, "India"))))), /*#__PURE__*/React.createElement("g", {
    id: "g_chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g_lineChart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g_move_line"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "move_line2",
    d: "M127.5 478V504",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "move_text",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.13,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 115,
    y: 523.729
  }, "1,960")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "move_line",
    d: "M129 452V379",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g_Xaxis"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M118.7 459.83V454.26H1340.91V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M118.7 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1,950"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1950,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 105.521,
    y: 469.254
  }, "1950"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M271.471 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1,960"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1960,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 258.301,
    y: 469.254
  }, "1960"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M424.25 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1,970"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1970,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 411.58,
    y: 469.254
  }, "1970"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M577.001 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1,980"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1980,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 563.851,
    y: 469.254
  }, "1980"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M729.801 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1,990"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1990,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 716.631,
    y: 469.254
  }, "1990"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M882.581 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2000,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 868.391,
    y: 469.254
  }, "2000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M1035.36 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,010"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2010,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 1022.18,
    y: 469.254
  }, "2010"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M1188.13 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,020"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2020,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1173.95,
    y: 469.254
  }, "2020"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M1340.91 453.75V459.83",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,030"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2030,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1326.72,
    y: 469.254
  }, "2030")))))), /*#__PURE__*/React.createElement("g", {
    id: "g_Yaxis"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M107 449.19H113.59V144.39H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M113.12 449.19H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: 0
  }, /*#__PURE__*/React.createElement("text", {
    id: "0_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 96.9199,
    y: 451.614
  }, "0"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M113.12 411.09H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "200,000,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: "200,000,000_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 46.1904,
    y: 413.684
  }, "200,000,000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M113.12 373H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "400,000,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: "400,000,000_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 46.1904,
    y: 375.754
  }, "400,000,000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M113.12 334.89H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "600,000,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: "600,000,000_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 46.1904,
    y: 337.824
  }, "600,000,000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M113.12 296.79H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "800,000,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: "800,000,000_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 46.1904,
    y: 299.894
  }, "800,000,000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M113.12 258.69H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1,000,000,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1,000,000,000_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 37.7402,
    y: 261.964
  }, "1,000,000,000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M113.12 220.59H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1,200,000,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1,200,000,000_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 37.7402,
    y: 224.034
  }, "1,200,000,000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M113.12 182.49H107",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "1,400,000,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1,400,000,000_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 37.7402,
    y: 186.104
  }, "1,400,000,000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1,600,000,000"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1,600,000,000_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 37.7402,
    y: 148.174
  }, "1,600,000,000")))))), /*#__PURE__*/React.createElement("g", {
    id: "Mainline1"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M118.19 344.86C123.28 344.28 128.38 343.7 133.47 343.03C138.56 342.36 143.65 341.62 148.75 340.87C153.85 340.12 158.93 339.3 164.02 338.5C169.11 337.7 174.21 336.93 179.3 336.11C184.39 335.29 189.49 334.4 194.58 333.56C199.67 332.72 204.76 331.94 209.86 331.09C214.96 330.24 220.04 329.35 225.13 328.48C230.22 327.61 235.32 326.56 240.41 325.85C245.5 325.14 250.6 324.51 255.69 324.25C260.78 323.99 265.88 323.97 270.97 323.87C276.06 323.77 281.15 323.8 286.25 323.67C291.378 323.454 296.482 322.856 301.52 321.88C306.62 320.98 311.71 319.48 316.8 318.21C321.89 316.94 326.99 315.54 332.08 314.27C337.17 313 342.26 311.82 347.36 310.6C352.46 309.38 357.54 308.14 362.63 306.96C367.72 305.78 372.82 304.71 377.91 303.52C383 302.33 388.1 301.12 393.19 299.83C398.28 298.54 403.37 297.16 408.47 295.83C413.57 294.5 418.65 293.14 423.74 291.83C428.83 290.52 433.93 289.16 439.02 287.88C444.11 286.6 449.21 285.37 454.3 284.15C459.39 282.93 464.48 281.73 469.58 280.57C474.68 279.41 479.76 278.26 484.86 277.19C489.96 276.12 495.04 275.14 500.13 274.19C505.22 273.24 510.32 272.35 515.41 271.48C520.5 270.61 525.6 269.78 530.69 268.96C535.78 268.14 540.87 267.39 545.97 266.57C551.07 265.75 556.15 264.93 561.24 264.06C566.33 263.19 571.43 262.3 576.52 261.38C581.61 260.46 586.71 259.53 591.8 258.55C596.89 257.57 601.98 256.47 607.08 255.45C612.18 254.43 617.26 253.45 622.35 252.45C627.44 251.45 632.54 250.58 637.63 249.6C642.72 248.62 647.82 247.6 652.91 246.54C658 245.48 663.09 244.36 668.19 243.2C673.29 242.04 678.37 240.77 683.46 239.56C688.55 238.35 693.65 237.13 698.74 235.94C703.83 234.75 708.93 233.61 714.02 232.41C719.11 231.21 724.21 229.88 729.3 228.73C734.39 227.58 739.48 226.46 744.58 225.51C749.68 224.56 754.76 223.8 759.85 223C764.94 222.2 770.04 221.45 775.13 220.7C780.22 219.95 785.32 219.23 790.41 218.53C795.5 217.83 800.59 217.12 805.69 216.46C810.79 215.8 815.87 215.15 820.96 214.52C826.05 213.89 831.15 213.3 836.24 212.71C841.33 212.12 846.43 211.55 851.52 210.99C856.61 210.43 861.7 209.9 866.8 209.35L882.07 207.7C887.17 207.15 892.26 206.59 897.35 206.06C902.44 205.53 907.54 205.06 912.63 204.5C917.72 203.94 922.81 203.5 927.91 202.98L943.19 201.47L958.46 199.93C963.56 199.423 968.654 198.903 973.74 198.37C978.827 197.837 983.914 197.293 989 196.74C994.087 196.2 999.18 195.653 1004.28 195.1L1019.55 193.39L1034.83 191.66C1039.92 191.09 1045.02 190.55 1050.11 189.97C1055.2 189.39 1060.3 188.77 1065.39 188.16C1070.48 187.55 1075.57 186.94 1080.66 186.35C1085.75 185.76 1090.84 185.17 1095.94 184.62C1101.04 184.07 1106.13 183.52 1111.22 182.99C1116.31 182.46 1121.41 181.99 1126.5 181.43C1131.59 180.87 1136.68 180.32 1141.78 179.84C1146.88 179.36 1151.95 178.91 1157.05 178.54C1162.15 178.17 1167.24 177.88 1172.34 177.63C1177.44 177.38 1182.51 177.17 1187.61 177.05C1192.71 176.93 1197.79 176.86 1202.88 176.86H1218.16C1223.26 176.86 1228.35 176.86 1233.44 176.86",
    stroke: "#D83F3F",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "line1_g3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line1_text3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Three-Child Policy",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 1157,
    y: 94.3182
  }, "Three-Child Policy  "))), /*#__PURE__*/React.createElement("text", {
    id: "Further liberalization",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 1157,
    y: 112.318
  }, "Further liberalization "))), /*#__PURE__*/React.createElement("text", {
    id: "Aiming to counter workforce decline.",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 1157,
    y: 130.318
  }, "Aiming to counter workforce decline.")))), /*#__PURE__*/React.createElement("g", {
    id: "line1_year3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "line1_year3_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 1150,
    y: 70.5455
  }, "2021 | China")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line1_icon3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "line1_circle3",
    cx: 1197.69,
    cy: 174.69,
    r: 4.69,
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 17",
    x1: 1196.5,
    y1: 172,
    x2: 1196.5,
    y2: 452,
    stroke: "black",
    strokeDasharray: "2 2"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "side_line1_3",
    x: 1147,
    y: 81,
    width: 6,
    height: 49,
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "line1_g2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line1_text2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Two-Child Policy",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 942,
    y: 134.318
  }, "Two-Child Policy   "))), /*#__PURE__*/React.createElement("text", {
    id: "Increased flexibility",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 942,
    y: 152.318
  }, "Increased flexibility"))), /*#__PURE__*/React.createElement("text", {
    id: "but birth rates remained low.",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 942,
    y: 170.318
  }, "but birth rates remained low.")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "line1_icon2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "line1_circle2",
    cx: 1121.69,
    cy: 181.69,
    r: 4.69,
    fill: "black"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "side_line1_2",
    x: 929,
    y: 119,
    width: 6,
    height: 53,
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line1_year2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "line1_year2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 926,
    y: 107.545
  }, "2016 | China"))))), /*#__PURE__*/React.createElement("g", {
    id: "line1_g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line1_text1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "One-Child Policy",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 384,
    y: 121.318
  }, "One-Child Policy "))), /*#__PURE__*/React.createElement("text", {
    id: "Implemented to curb population growth",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 384,
    y: 139.318
  }, "Implemented to curb population growth"))), /*#__PURE__*/React.createElement("text", {
    id: "This policy had significant impacts",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 384,
    y: 157.318
  }, "This policy had significant impacts"))), /*#__PURE__*/React.createElement("text", {
    id: "Birth rates dramatically reduced",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 384,
    y: 175.318
  }, "Birth rates dramatically reduced"))), /*#__PURE__*/React.createElement("text", {
    id: "Slowing population growth",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 384,
    y: 193.318
  }, "Slowing population growth"))), /*#__PURE__*/React.createElement("text", {
    id: "Skewed sex ratio (more males)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 384,
    y: 211.318
  }, "Skewed sex ratio (more males)&#10;"))), /*#__PURE__*/React.createElement("text", {
    id: "aging population and economic challenges.",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 382,
    y: 227.318
  }, "aging population and economic challenges.")))), /*#__PURE__*/React.createElement("g", {
    id: "line1_year1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "line1_year1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 365,
    y: 97.5455
  }, "1971-2016 | China")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "line1_icon1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "line1_circle1",
    cx: 438.69,
    cy: 288.69,
    r: 4.69,
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 13",
    x1: 438.5,
    y1: 294,
    x2: 438.5,
    y2: 458,
    stroke: "black",
    strokeDasharray: "2 2"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "side_line1_1",
    x: 365,
    y: 111,
    width: 6,
    height: 119,
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mainline2"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 24",
    d: "M118.19 380.48L133.47 379L148.75 377.47L164 375.87C169.1 375.337 174.194 374.797 179.28 374.25C184.367 373.703 189.46 373.14 194.56 372.56C199.647 371.993 204.74 371.417 209.84 370.83L225.11 369.07C230.21 368.47 235.3 367.89 240.39 367.28C245.48 366.67 250.58 366.08 255.67 365.45C260.76 364.82 265.86 364.19 270.95 363.54L286.23 361.54L301.5 359.54L316.78 357.46L332.06 355.34L347.34 353.23C352.43 352.53 357.52 351.85 362.61 351.16C367.7 350.47 372.8 349.78 377.89 349.06C382.98 348.34 388.08 347.62 393.17 346.88C398.26 346.14 403.35 345.38 408.45 344.62C413.55 343.86 418.63 343.08 423.72 342.3C428.81 341.52 433.91 340.72 439 339.92C444.09 339.12 449.19 338.3 454.28 337.47C459.37 336.64 464.46 335.8 469.56 334.94C474.66 334.08 479.74 333.22 484.84 332.35L500.11 329.72L515.39 327.07L530.67 324.36C535.757 323.44 540.85 322.513 545.95 321.58C551.05 320.647 556.14 319.697 561.22 318.73C566.32 317.757 571.414 316.757 576.5 315.73C581.587 314.703 586.68 313.683 591.78 312.67C596.867 311.65 601.96 310.617 607.06 309.57L622.33 306.39C627.43 305.317 632.524 304.233 637.61 303.14C642.697 302.047 647.79 300.947 652.89 299.84L668.17 296.48L683.44 293.08L698.72 289.65C703.807 288.497 708.9 287.333 714 286.16L729.28 282.65L744.56 279.13L759.83 275.58L775.13 272L790.41 268.4L805.69 264.78L821 261.18L836.28 257.55L851.56 253.91L866.84 250.28L882.11 246.63L897.35 243L912.63 239.32C917.724 238.087 922.817 236.873 927.91 235.68C933.004 234.487 938.097 233.287 943.19 232.08C948.277 230.9 953.367 229.733 958.46 228.58C963.554 227.427 968.647 226.303 973.74 225.21C978.827 224.09 983.92 222.99 989.02 221.91L1004.3 218.66L1019.57 215.44L1034.85 212.21L1050.13 208.97L1065.41 205.75C1070.5 204.69 1075.59 203.62 1080.68 202.58C1085.77 201.54 1090.86 200.52 1095.96 199.51C1101.06 198.5 1106.15 197.51 1111.24 196.51L1126.52 193.51C1131.61 192.51 1136.7 191.51 1141.8 190.51C1146.9 189.51 1151.97 188.61 1157.07 187.69C1162.17 186.77 1167.26 185.87 1172.36 185C1177.46 184.13 1182.53 183.25 1187.63 182.47C1192.73 181.69 1197.81 181 1202.9 180.34C1207.99 179.68 1213.1 179.18 1218.18 178.51C1223.26 177.84 1228.37 177.09 1233.46 176.33",
    stroke: "#195193",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "line2_g3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2_text3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Mission Parivar Vikas",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 957,
    y: 282.318
  }, "Mission Parivar Vikas"))), /*#__PURE__*/React.createElement("text", {
    id: "Aims to stabilize",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 957,
    y: 300.318
  }, "Aims to stabilize "))), /*#__PURE__*/React.createElement("text", {
    id: "population through",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 957,
    y: 318.318
  }, "population through"))), /*#__PURE__*/React.createElement("text", {
    id: "improved access",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 955,
    y: 333.318
  }, "improved access "))), /*#__PURE__*/React.createElement("text", {
    id: "to family planning.",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 955,
    y: 350.318
  }, "to  family planning.")))), /*#__PURE__*/React.createElement("g", {
    id: "line2_year3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "line2_year3_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 942,
    y: 256.545
  }, "2016 | India")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line2_icon3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "line2_circle3",
    cx: 1121.69,
    cy: 193.69,
    r: 4.69,
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 18",
    x1: 1121.5,
    y1: 454.002,
    x2: 1121.5,
    y2: 181,
    stroke: "black",
    strokeDasharray: "2 2"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "side_line2_3",
    x: 942,
    y: 267,
    width: 6,
    height: 89,
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "line2_g2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2_text2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Family Welfare Program",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 561,
    y: 379.318
  }, "Family Welfare Program"))), /*#__PURE__*/React.createElement("text", {
    id: "Emphasis on maternal and child health",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 561,
    y: 397.318
  }, "Emphasis on maternal and child health"))), /*#__PURE__*/React.createElement("text", {
    id: "Contraceptive options.",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 560,
    y: 414.318
  }, "Contraceptive options.")))), /*#__PURE__*/React.createElement("g", {
    id: "line2_year2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "line2_year2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 547,
    y: 352.545
  }, "1977 | India")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "line2_icon2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "line2_circle2",
    cx: 538.69,
    cy: 322.69,
    r: 4.69,
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 16",
    x1: 539.5,
    y1: 323,
    x2: 539.5,
    y2: 454,
    stroke: "black",
    strokeDasharray: "2 2"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "side_line2_2",
    x: 549,
    y: 364,
    width: 6,
    height: 50,
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "line2_g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2_text1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "National Family Planning Program",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 184,
    y: 414.318
  }, "National Family Planning Program"))), /*#__PURE__*/React.createElement("text", {
    id: "Promoted smaller families through",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 184,
    y: 432.318
  }, "Promoted smaller families through"))), /*#__PURE__*/React.createElement("text", {
    id: "education and incentives.",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 200,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 184,
    y: 450.318
  }, "education and incentives.")))), /*#__PURE__*/React.createElement("g", {
    id: "line2_year1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "line2_year1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 174,
    y: 393.545
  }, "1951 | India")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "line2_icon1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "line2_circle1",
    cx: 167.69,
    cy: 375.69,
    r: 4.69,
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    x1: 167.5,
    y1: 371,
    x2: 167.5,
    y2: 452,
    stroke: "black",
    strokeDasharray: "2 2"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "side_line2_1",
    x: 174,
    y: 400,
    width: 6,
    height: 50,
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g_gap"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "gap_line",
    d: "M128.5 343L128.5 380",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M128.5 358L129 358.5M129 358.5L131.5 361L129 363.5V358.5Z",
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "upper",
    d: "M126 343C128.928 343 129.173 343 128.928 343",
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "low",
    d: "M126 380C128.928 380 129.173 380 128.928 380",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "gap_text",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10.13,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 135,
    y: 363.684
  }, "1,960")))))), /*#__PURE__*/React.createElement("g", {
    id: "g_header"
  }, /*#__PURE__*/React.createElement("text", {
    id: "India and China: Divergent Paths in Population Growth",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 100,
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 354.228,
    y: 37.4091
  }, "India and China: Divergent Paths in Population Growth")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalSvg);
export default __webpack_public_path__ + "static/media/finalSvg.40a4d976d5bd2d29a42ca6436f095ac8.svg";
export { ForwardRef as ReactComponent };